import { BasicStorageManager } from '@bridebook/toolbox/src/storage-managers';
import { IAIPlannerUIState } from '@bridebook/web/lib/ai-planner/types';

export const AIPlannerUIStorage = BasicStorageManager<IAIPlannerUIState>({
  storageKey: 'ai-planner-ui',
});
